export default {
    A1: {
        t: 's',
        v: '',
    },
    A2: {
        t: 's',
        v: '',
    },
    H2: {
        t: 's',
        v: '',
    },
    A3: {
        t: 's',
        v: '科目代號',
    },
    B3: {
        t: 's',
        v: '科目名稱',
    },
    C3: {
        t: 's',
        v: '科目屬性',
    },
    D3: {
        t: 's',
        v: '期初借方餘額',
    },
    E3: {
        t: 's',
        v: '期初貸方餘額',
    },
    F3: {
        t: 's',
        v: '本期借方金額',
    },
    G3: {
        t: 's',
        v: '本期貸方金額',
    },
    H3: {
        t: 's',
        v: '期末借方餘額',
    },
    I3: {
        t: 's',
        v: '期末貸方餘額',
    },
    '!ref': 'A1:I3',
    '!merges': [
        { s: { c: 7, r: 1 }, e: { c: 8, r: 1 } },
        { s: { c: 0, r: 1 }, e: { c: 6, r: 1 } },
        { s: { c: 0, r: 0 }, e: { c: 8, r: 0 } },
    ],
};
